<template>
    <div class="flex flex-col w-full h-full gap-2 p-2">
        <div class="text-xl">Bruk dimensjoner for å gruppere bilag på prosjekt eller avdeling</div>
        <UCard class="flex flex-col overflow-visible" :ui="{body: 'grow'}">
            <template #header>
                Ny dimensjon
            </template>
            <div class="flex flex-col gap-2">
                <div class="flex gap-2 btn-group w-full">
                    <UButton
                        v-for="dimension in dimensionTypes"
                        :key="dimension"
                        size="xs"
                        color="neutral"
                        variant="subtle"
                        class="border-none grow flex justify-center"
                        :value="type"
                        :class="[
                            isActiveTypeColor(dimension) ? dimensionColor(dimension) : '',
                            isActiveTypeColor(dimension) ? 'text-white' : '',
                            isActiveTypeColor(dimension) ? 'hover:' + dimensionColor(dimension) : ''
                        ]"
                        @click="updateType(dimension)"
                    >
                        <i
                            class=""
                            :class="dimensionTypeIcon(dimension)"
                        />
                        <span>
                            {{ dimensionTypeText(dimension) }}
                        </span>
                    </UButton>
                </div>
                <UInput
                    v-model="name"
                    placeholder="Navn"
                    required
                    class="my-4 w-full"
                    data-cy="dimension-input"
                />
            </div>
            <template #footer>
                <div class="flex w-full justify-end">
                    <UButton @click="handleSave">Lagre</UButton>
                </div>
            </template>
        </UCard>
        <ag-grid-vue
            class="w-full h-full grow"
            :theme="agTheme"
            :grid-options="gridOptions"
            :row-data="dimensions"
            :column-defs="columnDefs"
        />
    </div>
</template>

<script setup lang="ts">

import {AgGridVue} from 'ag-grid-vue3'
import {Dimension, DimensionType} from '@/dimensions/Dimension'
import {putDimension, useDimensions} from '@/dimensions/dimensions.service'
import {onMounted, ref} from 'vue'
import {GridOptions, IRowNode} from 'ag-grid-community'
import {agTheme} from '@/agUtils/ag-theme.service'
import {dimensionColor, dimensionTypeIcon, dimensionTypeText} from '@/dimensions/dimensions.functions'
import TypeAndIconCellRenderer from '@/dimensions/TypeAndIconCellRenderer.vue'
import USwitchCellRenderer from '@/dimensions/USwitchCellRenderer.vue'
import {globalDefaultColDef} from '@/agUtils'

const {dimensions, fetch, createDimension} = useDimensions()
const name = ref<string>()
const type = ref<DimensionType>(DimensionType.PROJECT)

const dimensionTypes = ref([DimensionType.PROJECT, DimensionType.DEPARTMENT /*, DimensionType.TAG*/])

const updateType = (selectedType: DimensionType) => {
    type.value = selectedType
}

const isActiveTypeColor = (selectedType: DimensionType) => {
    if (selectedType === type.value) {
        return true
    }
}
const handleSave = async () => {
    if (name.value) {
        await createDimension({
            name: name.value,
            type: type.value,
            isEnabled: true
        })
        await fetch()
        name.value = ''
    }
}

const gridOptions: GridOptions = {
    getRowId: (params: { data: Dimension }) => `${params.data.name}${params.data.type}`,
    context: {
        refresh: () => {
            return fetch()
        }
    },
    defaultColDef: {
        ...globalDefaultColDef,
        sortable: true,
        resizable: true
    }
}

const handleToggleActive = async (dimension: Dimension) => {
    if (dimension.type === DimensionType.SYSTEM) return
    await putDimension({
        ...dimension,
        isEnabled: !dimension.isEnabled
    })
    await fetch()
}

const columnDefs = [
    {
        headerName: 'Navn',
        field: 'name',
        flex: 1
    },
    {
        headerName: 'Type',
        field: 'type',
        cellRenderer: TypeAndIconCellRenderer,
        cellRendererParams: ({data}: IRowNode) => {
            return {
                display: data.type
            }
        },
        width: 160
    },
    {
        headerName: 'Aktiv',
        field: 'isEnabled',
        width: 120,
        cellRenderer: USwitchCellRenderer,
        cellRendererParams: {
            toggle: handleToggleActive
        }
    }
]


onMounted(async () => {
    await fetch()
})
</script>

<style scoped>

</style>